import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import ScrollToTop from "@/components/ScrollToTop";
import RouteMeta from "@/components/RouteMeta";
import { loadWhatsAppConfig } from "@/lib/whatsapp";

export default function PublicLayout() {
  useEffect(() => {
    loadWhatsAppConfig();
  }, []);

  return (
    <ReactLenis root options={{ duration: 1.2, smoothWheel: true, lerp: 0.1 }}>
      <div className="App relative min-h-screen overflow-x-hidden bg-white text-[#1F152E]">
        <Header />
        <ScrollToTop />
        <RouteMeta />
        <main>
          <Outlet />
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </ReactLenis>
  );
}
